import { Box } from "@mui/material";
import { useEffect, useState } from "react";

export default function DRAP_OCU_B({ exercise, isRunning, velocity }) {
  const [currentWord, setCurrentWord] = useState(0);
  const [words, setWords] = useState(exercise.content.split(",").sort(function() { return Math.random() - 0.5 }));
  const velocidad = ((1000 / velocity) * 60);

  useEffect(() => {
    let timer = null
    if (isRunning && words.length > 0) {
      timer = setInterval(() => {
        setCurrentWord((prev) => (prev + 1) % words.length);
      }, velocidad);
    }

    return () => {
      if (timer) clearInterval(timer);
    }
  }, [isRunning, words]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%", // Cambia a 100vh para ocupar toda la altura de la ventana
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        background: "#ffffff",
      }}
    >
      <svg
        viewBox="0 0 400 100"
        preserveAspectRatio="xMidYMid meet"
        style={{
          width: "100%",
          maxWidth: "600px",
          height: "auto",
        }}
      >
        {/* Fondo azul */}
        <rect x="50" y="30" width="300" height="40" fill="#90CAF9" rx="4" />

        {/* Línea vertical central */}
        <line x1="200" y1="20" x2="200" y2="80" stroke="#666" strokeWidth="1" />

        {/* Texto animado */}
        <text
          x="200"
          y="50"
          textAnchor="middle"
          alignmentBaseline="middle"
          style={{
            fontSize: "24px",
            fontFamily: "Arial, sans-serif",
            fill: "#000",
            dominantBaseline: "middle", // Asegura el centrado vertical
          }}
        >
          {words[currentWord]}
        </text>
      </svg>
    </Box>
  );
}
